/*
 * Regras puras dos cadastros básicos do administrativo (Programa, Tipo de
 * Habitação, Tipo de Moradia e Documento): limites dos campos, montagem do
 * corpo enviado ao back e mensagens de sucesso.
 */

export const TAMANHO_MAXIMO_DESCRICAO = 200;
export const TAMANHO_MAXIMO_NOME = 200;
export const TAMANHO_MAXIMO_HTML = 4000;
export const ORDEM_MAXIMA = 9999;

export const ACOES = Object.freeze({
    CRIAR: 'criar',
    ATUALIZAR: 'atualizar',
    EXCLUIR: 'excluir'
});

const PARTICIPIOS = {
    [ACOES.CRIAR]: 'criado',
    [ACOES.ATUALIZAR]: 'atualizado',
    [ACOES.EXCLUIR]: 'excluído'
};

/*
 * O editor rico (Quill) devolve `<p><br></p>` quando está vazio. Vazio é o HTML
 * que, sem as tags, sem `&nbsp;` e sem espaços, não deixa nenhum texto.
 */
export const htmlVazio = html => {
    if (html === null || html === undefined) {
        return true;
    }

    return String(html)
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;|&#160;|&#xa0;/gi, ' ')
        .replace(/[\s\u00A0\u200B]+/g, '')
        .length === 0;
};

/* Corpo de Programa, Tipo de Habitação e Tipo de Moradia. */
export const montarPayloadDescricao = valores => ({
    descricao: String(valores?.descricao ?? '').trim()
});

/* Corpo de Documento: a descrição é HTML e segue como o editor devolveu. */
export const montarPayloadDocumento = valores => ({
    ordem: Number(valores?.ordem),
    nome: String(valores?.nome ?? '').trim(),
    descricao: valores?.descricao ?? ''
});

/*
 * Mensagem de sucesso: "Programa criado com sucesso!". Todos os itens destes
 * cadastros são masculinos (programa, tipo, documento).
 */
export const mensagemSucesso = (nomeItem, acao) => {
    const participio = PARTICIPIOS[acao];

    if (!participio) {
        throw new Error(`Ação desconhecida: ${acao}`);
    }

    return `${nomeItem} ${participio} com sucesso!`;
};
